import { DBConnectorService } from './test.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class ManageService {

    constructor(private http: HttpClient,
        private dbconnectorservice: DBConnectorService) {

    }

    //#region Manage User

    createUser(dbData) {
        const url = '/api/ManageUser/CreateUser';
        const options = {
            headers: new HttpHeaders({
                'UserName': this.dbconnectorservice.username,
                'IpAddress': this.dbconnectorservice.ipaddress
            })
        }
        return this.http.post<any>(url, dbData, options) // add the json file
    }

    deleteUser(dbData) {
        const url = '/api/ManageUser/DeleteConfirmedUser';
        const options = {
            headers: new HttpHeaders({
                'UserName': this.dbconnectorservice.username,
                'IpAddress': this.dbconnectorservice.ipaddress
            })
        }
        return this.http.post<any>(url, dbData, options) // add the json file
    }

    editUser(dbData) {
        const url = '/api/ManageUser/EditUser';
        const options = {
            headers: new HttpHeaders({
                'UserName': this.dbconnectorservice.username,
                'IpAddress': this.dbconnectorservice.ipaddress
            })
        }
        return this.http.post<any>(url, dbData, options) // add the json file
    }

    GetUserDetails(dbData) {
        const url = '/api/ManageUser/GetUserDetail';
        const options = {
            headers: new HttpHeaders({
                'UserName': this.dbconnectorservice.username,
                'IpAddress': this.dbconnectorservice.ipaddress
            })
        }
        return this.http.post<any>(url, dbData, options) // add the json file
    }

    //#endregion Manage User

    //#region Manage Sector

    createSector(dbData) {
        const url = '/api/ManageSector/CreateSector';
        const options = {
            headers: new HttpHeaders({
                'UserName': this.dbconnectorservice.username,
                'IpAddress': this.dbconnectorservice.ipaddress
            })
        }
        return this.http.post<any>(url, dbData, options) // add the json file
    }

    deleteSector(dbData) {
        const url = '/api/ManageSector/DeleteConfirmedSector';
        const options = {
            headers: new HttpHeaders({
                'UserName': this.dbconnectorservice.username,
                'IpAddress': this.dbconnectorservice.ipaddress
            })
        }
        return this.http.post<any>(url, dbData, options) // add the json file
    }

    createCloneSector(dbData) {
        const url = '/api/ManageSector/CreateCloneSector';
        const options = {
            headers: new HttpHeaders({
                'UserName': this.dbconnectorservice.username,
                'IpAddress': this.dbconnectorservice.ipaddress
            })
        }
        return this.http.post<any>(url, dbData, options) // add the json file
    }

    //#endregion Manage Sector


    //#region Manage Model

    createModel(dbData) {
        const url = '/api/ManageModel/CreateModel';
        const options = {
            headers: new HttpHeaders({
                'UserName': this.dbconnectorservice.username,
                'IpAddress': this.dbconnectorservice.ipaddress
            })
        }
        return this.http.post<any>(url, dbData, options) // add the json file
    }

    deleteModel(dbData) {
        const url = '/api/ManageModel/DeleteConfirmedModel';
        const options = {
            headers: new HttpHeaders({
                'UserName': this.dbconnectorservice.username,
                'IpAddress': this.dbconnectorservice.ipaddress
            })
        }
        return this.http.post<any>(url, dbData, options) // add the json file
    }

    //#endregion Manage Model

    //#region Manage Label

    createLabel(dbData) {
        const url = '/api/ManageLabel/CreateLabel';
        const options = {
            headers: new HttpHeaders({
                'UserName': this.dbconnectorservice.username,
                'IpAddress': this.dbconnectorservice.ipaddress
            })
        }
        return this.http.post<any>(url, dbData, options) // add the json file
    }

    deleteLabel(dbData) {
        const url = '/api/ManageLabel/DeleteConfirmedLabel';
        const options = {
            headers: new HttpHeaders({
                'UserName': this.dbconnectorservice.username,
                'IpAddress': this.dbconnectorservice.ipaddress
            })
        }
        return this.http.post<any>(url, dbData, options) // add the json file
    }

    //#endregion Manage Label

    //#region Manage Backup
    BackupTab(dbData) {
        const url = '/api/ManageBackup/BackupTab';
        return this.http.post<any>(url, dbData)
    }

    ShowExcelFiles(dbData) {
        const url = '/api/ManageBackup/ExcelFiles';
        return this.http.post<any>(url, dbData)
    }

    ShowLabelMapping(dbData) {
        const url = '/api/ManageBackup/LabelMapping';
        return this.http.post<any>(url, dbData)
    }
    //#endregion Manage Backup

    //#region Log
    getLogDetail() {
        const url = '/api/ManageLog/GetLogDetail';
        return this.http.get<any>(url)
    }
    //#endregion Log

}
